const IconCarryOnLuggageAvailable = props => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.82 10.44H14.67V3.34H14.86C15.34 3.34 15.63 3.05 15.63 2.57C15.63 2.09 15.25 1.8 14.86 1.8H9.09995C8.61995 1.8 8.32995 2.18 8.32995 2.57C8.32995 2.96 8.70995 3.34 9.09995 3.34H9.28995V10.45H8.13995C6.59995 10.45 5.44995 11.7 5.44995 13.14V18.42C5.44995 19.86 6.50995 20.92 7.84995 21.11V21.69C7.84995 22.17 8.22995 22.46 8.61995 22.46H9.09995C9.57995 22.46 9.86995 22.08 9.86995 21.69V21.11H14.1V21.69C14.1 22.17 14.48 22.46 14.87 22.46H15.35C15.83 22.46 16.12 22.08 16.12 21.69V21.11C17.46 20.92 18.52 19.77 18.52 18.42V13.14C18.52 11.6 17.27 10.45 15.83 10.45L15.82 10.44ZM10.83 3.34H13.13V10.45H10.83V3.34ZM8.94995 13.73C8.94995 13.38 9.22995 13.1 9.57995 13.1H14.42C14.77 13.1 15.05 13.38 15.05 13.73C15.05 14.08 14.77 14.36 14.42 14.36H13.54V15.44C13.54 15.74 13.3 15.98 13 15.98C12.7 15.98 12.46 15.74 12.46 15.44V14.36H9.57995C9.22995 14.36 8.94995 14.08 8.94995 13.73Z"
			fill="currentColor"
		/>
	</svg>
);

export default IconCarryOnLuggageAvailable;
